var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_565_67122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_565_67122)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 6H6V1.33333H1.33333V6ZM6 0H1.33333C0.6 0 0 0.6 0 1.33333V6C0 6.73333 0.6 7.33333 1.33333 7.33333H6C6.73333 7.33333 7.33333 6.73333 7.33333 6V1.33333C7.33333 0.6 6.73333 0 6 0ZM1.33333 14.6667H6V10H1.33333V14.6667ZM6 8.66667H1.33333C0.6 8.66667 0 9.26667 0 10V14.6667C0 15.4 0.6 16 1.33333 16H6C6.73333 16 7.33333 15.4 7.33333 14.6667V10C7.33333 9.26667 6.73333 8.66667 6 8.66667ZM14.6667 14.6667H10V10H14.6667V14.6667ZM10 8.66667H14.6667C15.4 8.66667 16 9.26667 16 10V14.6667C16 15.4 15.4 16 14.6667 16H10C9.26667 16 8.66667 15.4 8.66667 14.6667V10C8.66667 9.26667 9.26667 8.66667 10 8.66667ZM10 6H14.6667V1.33333H10V6ZM14.6667 0H10C9.26667 0 8.66667 0.6 8.66667 1.33333V6C8.66667 6.73333 9.26667 7.33333 10 7.33333H14.6667C15.4 7.33333 16 6.73333 16 6V1.33333C16 0.6 15.4 0 14.6667 0Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b963ddd909828a99c55b400aa754109b.svg";
export { ForwardRef as ReactComponent };